import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { zhanden } from '@src/utils/zhanden'; 

const FormSubmit = ({ clickSubmitHandle, saveFormDataHandle, languages }) => {
    // const surveyEndHandle = () => {
    //     alert('报名已结束');
    // };

    return (
        <div className={styles.formSubmit}>
            <div
                className={styles.formSubmitSave}
                onClick={saveFormDataHandle}
                style={{ backgroundImage: `url(${zhanden[languages].button.save})` }}
            />
            <div
                className={styles.formSubmitButton}
                onClick={() => {
                    clickSubmitHandle(true);
                }}
                style={{ backgroundImage: `url(${zhanden[languages].button.submit})` }}
            />
        </div>
    );
};

FormSubmit.propTypes = {
    clickSubmitHandle: PropTypes.func,
    saveFormDataHandle: PropTypes.func,
    languages: PropTypes.string
};

export default errorBoundary(FormSubmit);
